import { Navigate, useParams } from "react-router-dom";
import { useTranslations } from "next-intl";
import { JoinRequestsAdmin } from "@/components/admin/join-requests-admin";
import { Heading, PageShell, Text } from "@/components/ui";
import { useAuthStore } from "@/stores/authStore";

export function TenantAdminJoinRequestsPage() {
  const { tenantSlug = "" } = useParams<{ tenantSlug: string }>();
  const t = useTranslations("allowlist");
  const user = useAuthStore((state) => state.user);
  const isAuthenticated = useAuthStore((state) => state.isAuthenticated);

  if (!isAuthenticated) {
    return <Navigate to={`/t/${tenantSlug}/login`} replace />;
  }
  if (user?.role !== "tenant_admin") {
    return <Navigate to={`/t/${tenantSlug}/dashboard`} replace />;
  }

  return (
    <PageShell width="app" data-testid="tenant-admin-join-requests">
      <Heading as="h1" level="page">
        {t("requestsTitle")}
      </Heading>
      <Text tone="muted" className="mt-2">
        {t("requestsSubtitle")}
      </Text>
      <div className="mt-8">
        <JoinRequestsAdmin />
      </div>
    </PageShell>
  );
}
